export default __webpack_public_path__ + "110555e8b647bcc68d40b3a593fdddeb.png";